import { environment } from "environments/environment";

export const featureFlagsCRM:Record<string, boolean> = {
  enableLoyaltyPoints: true,
  enableInstallationPictures: true,
  enableCallTrend: true,
  enableCCOLeads: true,
  enableBuyoutChecks: true
}
